import React, { useState } from "react";
import { createPortal } from "react-dom";

const Iframe = ({ children, ...props }) => {
  const [contentRef, setContentRef] = useState(null);
  const mountNode = contentRef && contentRef.contentWindow.document.body;

  return (
    <iframe
      title="preview"
      height="100%"
      className="bg-white shadow"
      {...props}
      ref={setContentRef}
    >
      {mountNode && createPortal(React.Children.only(children), mountNode)}
    </iframe>
  );
};

export default Iframe;
